export class StringValidationUtil {
  static isEmailValid(v: string): boolean {
    return !v || /^\w+([.+-]\w+)*@\w+([.-]\w+)*\.\w{2,8}$/.test(v);
  }
  static isNullOrWhitespace(v: string | null | undefined): boolean {
    return !v || /^\s*$/.test(v);
  }
}
